<template>
  <nav
    class="navbar is-fixed-bottom is-hidden-desktop"
    role="navigation"
    aria-label="main navigation"
    v-if="selectedCar"
  >
    <div class="navbar-brand">
      <a class="navbar-item" @click.prevent="">
        <figure class="image is-32x32">
          <img src="https://bulma.io/images/placeholders/128x128.png">
        </figure>
      </a>
      <router-link :to="{ name: 'gas', params: { id: selectedCar.id } }" class="navbar-item">
        <font-awesome-icon icon="gas-pump" size="2x"/>
      </router-link>
      <router-link :to="{ name: 'expenses', params: { id: selectedCar.id } }" class="navbar-item">
        <font-awesome-icon icon="wallet" size="2x"/>
      </router-link>
      <router-link :to="{ name: 'reminders', params: { id: selectedCar.id } }" class="navbar-item">
        <font-awesome-icon icon="bell" size="2x"/>
      </router-link>
      <router-link :to="{ name: 'statistics', params: { id: selectedCar.id } }" class="navbar-item">
        <font-awesome-icon icon="chart-line" size="2x"/>
      </router-link>

      <a role="button"
         class="navbar-burger"
         aria-label="menu"
         aria-expanded="false"
         @click="isMenuOpen = !isMenuOpen"
      >
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>

    <div class="navbar-menu" v-bind:class="{ 'is-active': isMenuOpen }">
      <div class="navbar-start">
        <a
          class="navbar-item"
          v-for="car in cars"
          v-bind:key="car.id"
          @click.prevent="selectedCar = car"
          v-bind:class="{ active: selectedCar === car }"
        >
          {{ car.make }} {{ car.model }}
        </a>
        <router-link :to="{ name: 'cars' }" class="navbar-item">
          Cars
        </router-link>
        <router-link :to="{ name: 'settings' }" class="navbar-item">
          Settings
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import CARS from '@/graphql/cars/cars.gql';

export default {
  name: 'MobileMenu',
  data() {
    return {
      selectedCar: null,
      isMenuOpen: false,
    };
  },
  apollo: {
    cars: {
      query: CARS,
      result({ data }) {
        const { cars } = data;
        if (!this.selectedCar) {
          this.selectedCar = cars[0]; // eslint-disable-line
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  padding-bottom: 2rem;
}
</style>
